export default __webpack_public_path__ + "static/media/pageFlip.601790b3.mp3";